module.exports = __webpack_public_path__ + "img/@web_link.1d345cc0.svg";